<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
  >
    <template v-slot:header="{ cancel }">
      <div>
        <v-card-title class="screen-title"
          >Palo Alto向けVNコネクト設定</v-card-title
        >
      </div>

      <div class="d-flex flex-row align-start ga-2">
        <v-btn color="primary" @click="downloadConfig">設定ダウンロード</v-btn>
        <v-btn color="primary" @click="uploadConfig">設定アップロード</v-btn>
        <button
          type="button"
          aria-label="Close"
          class="close ml-5"
          @click="cancel"
        >
          ×
        </button>
      </div>
    </template>

    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <cross-validation-observer
        :initial-values="{
          routeAggregationAddressList:
            form.saseGatewayVnConnectCommon.routeAggregationAddressList &&
            form.saseGatewayVnConnectCommon.routeAggregationAddressList.length >
              0
              ? form.saseGatewayVnConnectCommon.routeAggregationAddressList
              : [''],
        }"
        v-slot="{ handleSubmit }"
        as="div"
      >
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <!-- 基本設定 -->
                <v-row>
                  <v-col>
                    <h3>基本設定</h3>
                  </v-col>
                </v-row>
                <!-- サービスキー(Act) -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="サービスキー(Act)"
                      :is-info="false"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="serviceKeyAct"
                        label="サービスキー(Act)"
                        v-model="
                          (form as SaseGatewayPaloAltoPost)
                            .saseGatewayVnConnectAct.serviceKey
                        "
                        :rules="{ required: true }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-form-input
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <template v-else>
                      <app-form-input
                        :value="
                          saseGatewayPaloAltoDetail!.saseGatewayVnConnectAct
                            .serviceKey
                        "
                        disabled
                      />
                    </template>
                  </v-col>
                </v-row>
                <!-- サービスキー(Sby) -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="サービスキー(Sby)"
                      :is-info="false"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="serviceKeySby"
                        label="サービスキー(Sby)"
                        v-model="
                          (form as SaseGatewayPaloAltoPost)
                            .saseGatewayVnConnectSby.serviceKey
                        "
                        :rules="{
                          required: true,
                          is_not_eq: {
                            target: '@serviceKeyAct',
                            targetField: 'サービスキー(Act)',
                          },
                        }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-form-input
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <template v-else>
                      <app-form-input
                        :value="
                          saseGatewayPaloAltoDetail!.saseGatewayVnConnectSby!
                            .serviceKey
                        "
                        disabled
                      />
                    </template>
                  </v-col>
                </v-row>
                <!--ロケーション-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="ロケーション"
                      :is-info="false"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="location"
                        label="ロケーション"
                        v-model="
                          (form as SaseGatewayPaloAltoPost)
                            .saseGatewayVnConnectCommon.location
                        "
                        :rules="{ required: true }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-select
                          :items="locationOptions"
                          item-title="text"
                          item-value="value"
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <app-form-input
                      v-else
                      :value="
                        $filter.enumTo(
                          saseGatewayPaloAltoDetail!.saseGatewayVnConnectCommon
                            .location,
                          'location'
                        )
                      "
                      disabled
                    />
                  </v-col>
                </v-row>
                <!--接続先仮想ネットワーク(VPN/VN)名-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="接続先仮想ネットワーク(VPN/VN)名"
                      :is-info="false"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="selectedVpnVn"
                        label="接続先仮想ネットワーク(VPN/VN)名"
                        v-model="selectedVpnVn"
                        :rules="{ required: true }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-select-search
                          :items="vpnVnCodeSelectList"
                          item-title="text"
                          item-value="value"
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <!--変更の場合、変更不可-->
                    <app-form-input v-else :value="vpnVnName" disabled />
                  </v-col>
                </v-row>

                <!-- VNコネクト設定 -->
                <v-row>
                  <v-col>
                    <h3>VNコネクト設定</h3>
                  </v-col>
                </v-row>
                <!--品目-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="品目"
                      :is-info="false"
                      :isRequired="true"
                    />
                    <validation-provider
                      name="bandwidth"
                      label="品目"
                      v-model="form.saseGatewayVnConnectCommon.bandwidth"
                      :rules="{ required: true }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-select
                        :items="bandwidthSelectList"
                        item-title="text"
                        item-value="value"
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--VNコネクト名(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="VNコネクト名(Act)"
                      :msg="
                        $filter.message('info_max_length', {
                          maxLength: '20',
                        })
                      "
                      :is-info="true"
                      :isRequired="true"
                    />
                    <validation-provider
                      name="vnConnectNameAct"
                      label="VNコネクト名(Act)"
                      v-model="form.saseGatewayVnConnectAct!.vnConnectName"
                      :rules="{
                        required: true,
                        max: { length: 20 },
                        alpha_num_zenkaku: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--VNコネクト名(Sby)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="VNコネクト名(Sby)"
                      :msg="
                        $filter.message('info_max_length', {
                          maxLength: '20',
                        })
                      "
                      :is-info="true"
                      :isRequired="true"
                    />
                    <validation-provider
                      name="vnConnectNameSby"
                      label="VNコネクト名(Sby)"
                      v-model="form.saseGatewayVnConnectSby!.vnConnectName"
                      :rules="{
                        required: true,
                        max: { length: 20 },
                        alpha_num_zenkaku: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <!-- ルーティング情報(共通) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(共通)</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group label="ルーティング種別" value="BGP4" />
                  </v-col>
                </v-row>
                <!--AS番号-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="AS番号"
                      :is-info="false"
                      :isRequired="false"
                    />
                    <app-form-input
                      :value="
                        (form as SaseGatewayPaloAltoPost)
                          .saseGatewayVnConnectCommon!.asNumber
                      "
                      disabled
                    />
                  </v-col>
                </v-row>
                <!--Maximum Prefix-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="Maximum Prefix"
                      :is-info="false"
                      :isRequired="true"
                    />
                    <validation-provider
                      name="maximumPrefix"
                      label="Maximum Prefix"
                      v-model="form.saseGatewayVnConnectCommon.maximumPrefix"
                      :rules="{ required: true }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-select
                        :items="maximumPrefixSelectList"
                        item-title="text"
                        item-value="value"
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <!-- ルーティング情報(Act) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(Act)</h3>
                  </v-col>
                </v-row>
                <!--WANアドレス(Act)-->
                <v-row>
                  <v-col>
                    <app-label-group label="WANアドレス">
                      <template #value
                        ><app-form-input
                          :value="
                            saseGatewayPaloAltoDetail?.saseGatewayVnConnectAct
                              .wanAddress
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--ピアIPアドレス(Act)-->
                <v-row>
                  <v-col>
                    <app-label-group label="ピアIPアドレス">
                      <template #value>
                        <app-form-input
                          :value="
                            saseGatewayPaloAltoDetail?.saseGatewayVnConnectAct
                              .peerIpAddress
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--Local Preference(Act)-->
                <v-row>
                  <v-col>
                    <app-label-group label="Local Preference">
                      <template #value>
                        <app-form-input
                          :value="
                            $filter.enumTo('HIGH_PRIORITY', 'localPreference')
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--MED(Act)-->
                <v-row>
                  <v-col>
                    <app-label-group label="MED">
                      <template #value>
                        <app-form-input
                          :value="$filter.enumTo('LOW_PRIORITY', 'med')"
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>

                <!-- ルーティング情報(Sby) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(Sby)</h3>
                  </v-col>
                </v-row>
                <!--WANアドレス(Sby)-->
                <v-row>
                  <v-col>
                    <app-label-group label="WANアドレス">
                      <template #value>
                        <app-form-input
                          :value="
                            saseGatewayPaloAltoDetail?.saseGatewayVnConnectSby
                              .wanAddress
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--ピアIPアドレス(Sby)-->
                <v-row>
                  <v-col>
                    <app-label-group label="ピアIPアドレス">
                      <template #value>
                        <app-form-input
                          :value="
                            saseGatewayPaloAltoDetail?.saseGatewayVnConnectSby
                              .peerIpAddress
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--Local Preference(Sby)-->
                <v-row>
                  <v-col>
                    <app-label-group label="Local Preference">
                      <template #value>
                        <app-form-input
                          :value="
                            $filter.enumTo('LOW_PRIORITY', 'localPreference')
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--MED(Sby)-->
                <v-row>
                  <v-col>
                    <app-label-group label="MED">
                      <template #value>
                        <app-form-input
                          :value="$filter.enumTo('HIGH_PRIORITY', 'med')"
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>

                <!-- カスタム経路集約情報 -->
                <v-row>
                  <v-col>
                    <h3>カスタム経路集約情報</h3>
                  </v-col>
                </v-row>
                <!--経路集約-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="経路集約"
                      :isRequired="false"
                      :isInfo="false"
                    />
                    <v-radio-group
                      v-model="form.saseGatewayVnConnectCommon.routeAggregation"
                      hide-details
                      inline
                    >
                      <v-radio
                        v-for="(routeOption, index) in routeOptions"
                        :key="`${routeOption.text + index}`"
                        :label="routeOption.text"
                        :value="routeOption.value"
                      />
                    </v-radio-group>
                  </v-col>
                </v-row>
                <!--経路集約アドレス-->
                <v-row
                  v-if="
                    form.saseGatewayVnConnectCommon.routeAggregation ===
                    'CUSTOM'
                  "
                >
                  <v-col>
                    <app-badge
                      item="経路集約アドレス"
                      :is-required="true"
                      :is-info="true"
                      :msg="$filter.message('info_routing_address')"
                    />
                    <validation-array
                      name="routeAggregationAddressList"
                      v-slot="{ fields, push, remove }"
                    >
                      <template v-for="(item, index) in fields" :key="item.key">
                        <v-row class="ga-2">
                          <validation-provider
                            :name="`routingIp_${item.key}`"
                            label="経路集約アドレス"
                            v-model="
                              form.saseGatewayVnConnectCommon
                                .routeAggregationAddressList![index]
                            "
                            :rules="{
                              required: true,
                              is_ip_subnet: { min: 1, max: 30 },
                              is_network_address: true,
                              is_not_default_root: true,
                              duplicate: { list: routingAddressList(index) },
                            }"
                            v-slot="{ componentField, errorMessage, meta }"
                          >
                            <app-form-input
                              class="ml-1"
                              :placeholder="
                                $filter.message(
                                  'placeholder_ip_address_with_subnet24'
                                )
                              "
                              v-bind="componentField"
                              :field-meta="meta"
                              :error-messages="errorMessage"
                            />
                            <v-btn
                              icon="$mdiMinus"
                              size="small"
                              variant="outlined"
                              class="rounded-sm ml-2 mr-3"
                              @click="removeRouteAddress(index, remove)"
                            />
                          </validation-provider>
                        </v-row>
                      </template>
                      <!--経路集約アドレス追加-CUSTOMのみ表示-->
                      <v-row justify="end">
                        <v-btn
                          icon="$mdiPlus"
                          size="small"
                          variant="outlined"
                          class="rounded-sm ml-2 mr-3"
                          :disabled="currentLength >= 100"
                          @click="addRouteAddress(push)"
                        />
                      </v-row>
                    </validation-array>
                  </v-col>
                </v-row>

                <!-- 保守連絡先情報 -->
                <v-row>
                  <v-col>
                    <h3>保守連絡先情報</h3>
                  </v-col>
                </v-row>
                <!--   コピー元回線番号 -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="コピー元回線番号"
                      :msg="$filter.message('info_maintenance_copy')"
                      :isRequired="false"
                      placement="end"
                    />
                    <div class="d-flex ga-2 align-start">
                      <div class="flex-grow-1">
                        <app-multi-select
                          v-model="selectedUnit"
                          :options="sortPaloAltoItems"
                          :custom-label="labelUnit"
                          track-by="_trackKey"
                          hide-details
                          class="mb-2"
                        >
                          <template #beforeList>
                            <div class="multiselect-thead">
                              <p>VPN/VNコード</p>
                              <p>VNコネクト名</p>
                              <p>VNコネクト番号</p>
                              <p>タイプ</p>
                              <p>ロケーション</p>
                            </div>
                          </template>
                          <template #option="{ option }">
                            <div class="multiselect-tbody">
                              <p>
                                {{
                                  option.saseGatewayVnConnectCommon.vpnVnCode.startsWith(
                                    "D"
                                  )
                                    ? `${option.saseGatewayVnConnectCommon.vpnVnCode}(${option.saseGatewayVnConnectCommon.vnType})`
                                    : option.saseGatewayVnConnectCommon
                                        .vpnVnCode
                                }}
                              </p>
                              <p>
                                {{
                                  option.saseGatewayVnConnectAct.vnConnectName
                                }}
                              </p>
                              <p>
                                {{ option.saseGatewayVnConnectAct.wnumber }}
                              </p>
                              <p>
                                {{
                                  $filter.enumTo(
                                    option.saseGatewayVnConnectCommon
                                      .saseGatewayServiceType,
                                    "saseGatewayServiceType"
                                  )
                                }}
                              </p>
                              <p>
                                {{
                                  $filter.enumTo(
                                    option.saseGatewayVnConnectCommon.location,
                                    "location"
                                  )
                                }}
                              </p>
                            </div>
                          </template>
                        </app-multi-select>
                      </div>
                      <v-btn
                        color="primary"
                        @click="setProperty"
                        :disabled="!selectedUnit"
                        >コピー
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <!-- 会社名 -->
                <v-row>
                  <v-col>
                    <validation-provider
                      name="company"
                      v-model="form.maintenance.company"
                      label="会社名"
                      :rules="{ required: true, max: { length: 35 } }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-badge
                        item="会社名"
                        :msg="
                          $filter.message('info_max_length', {
                            maxLength: '35',
                          })
                        "
                        placement="end"
                      />
                      <app-form-input
                        v-bind="componentField"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- 部署名 -->
                <v-row>
                  <v-col>
                    <validation-provider
                      name="department"
                      v-model="form.maintenance.department"
                      label="部署名"
                      :rules="{ required: true, max: { length: 35 } }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-badge
                        item="部署名"
                        :msg="
                          $filter.message('info_max_length', {
                            maxLength: '35',
                          })
                        "
                        placement="end"
                      />
                      <app-form-input
                        v-bind="componentField"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- 担当者名 -->
                <v-row>
                  <v-col>
                    <validation-provider
                      name="name"
                      v-model="form.maintenance.name"
                      label="担当者名"
                      :rules="{ required: true, max: { length: 20 } }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-badge
                        item="担当者名"
                        :msg="
                          $filter.message('info_max_length', {
                            maxLength: '20',
                          })
                        "
                        placement="end"
                      />
                      <app-form-input
                        v-bind="componentField"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- 電話番号 -->
                <v-row>
                  <v-col>
                    <validation-provider
                      name="phone"
                      v-model="form.maintenance.phone"
                      label="電話番号"
                      :rules="{
                        required: true,
                        is_phone_number: { max: 11 },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-badge
                        item="電話番号"
                        :msg="
                          $filter.message('info_tel', {
                            max: '11',
                          })
                        "
                        placement="end"
                      />
                      <app-form-input
                        v-bind="componentField"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- メールアドレス -->
                <v-row>
                  <v-col>
                    <validation-provider
                      name="email"
                      v-model="form.maintenance.email"
                      label="メールアドレス"
                      :rules="{
                        required: true,
                        max: { length: 127 },
                        is_email: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-badge
                        item="メールアドレス"
                        :msg="
                          $filter.message('info_sign_num_max', {
                            sign: '. _ ! ? { } + - * / = # % $ & ^ ` ~ | @',
                            max: 127,
                          })
                        "
                        placement="end"
                      />
                      <app-form-input
                        v-bind="componentField"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <!--備考-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="備考"
                      :msg="
                        $filter.message('info_max_length', { maxLength: '20' })
                      "
                      :is-info="true"
                      :isRequired="false"
                    />
                    <validation-provider
                      name="description"
                      label="備考"
                      v-model="form.saseGatewayVnConnectCommon.description"
                      :rules="{ max: { length: 20 } }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-container>
            </div>
            <v-alert v-if="!!uploadAlert" class="my-4" :text="uploadAlert" />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" color="primary" variant="flat">{{
                  isAdd ? "追加" : "変更"
                }}</v-btn>
                <v-btn color="primary" variant="outlined" @click="cancel"
                  >キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </cross-validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { VpnVnCode } from "@/apis/InformationApi";
import cloneDeep from "lodash/cloneDeep";
import type { BandWidth } from "@/apis/CloudVnMsApi";
import type {
  SaseGatewayListEntity,
  SaseGatewayPaloAltoDetailEntity,
  SaseGatewayPaloAltoPost,
  SaseGatewayPaloAltoPut,
} from "@/apis/SaseGatewayApi";
import type { UpperLimitEntity } from "@/apis/UpperLimitApi";
import { UploadError } from "@/services/ConfigDownloadService";
import SaseGatewayPaloAltoVnConnectionConfirm from "@/modals/saseGateway/paloalto/SaseGatewayPaloAltoVnConnectionConfirm.vue";

export default defineComponent({
  name: "SaseGatewayPaloAltoEdit",
  props: {
    // 変更の場合用
    saseGatewayPaloAltoDetail: {
      type: Object as PropType<SaseGatewayPaloAltoDetailEntity>,
      required: false,
      default: undefined,
    },
    // 追加の場合用
    saseGatewayKeyId: {
      type: String as PropType<string>,
      required: false,
      default: undefined,
    },
    /** 保守連絡先情報取得用アプライアンス情報 */
    paloAltoItems: {
      type: Array as PropType<SaseGatewayListEntity[]>,
      required: true,
    },
    /** VNコネクト帯域値(Mbps) */
    saseGatewayBandwidthUpperLimit: {
      type: Number as PropType<number>,
      required: true,
    },
    /** SASEゲートウェイ残り帯域値(Gbps) */
    saseGatewayRemainingBandwidth: {
      type: Number as PropType<number>,
      required: true,
      default: 0,
    },
  },
  data() {
    // 新規/更新のformデータを作成
    const form: SaseGatewayPaloAltoPost | SaseGatewayPaloAltoPut = (() => {
      if (this.saseGatewayPaloAltoDetail) {
        // 変更
        const saseGatewayPaloAltoDetailCopy = cloneDeep(
          this.saseGatewayPaloAltoDetail
        );
        // 経路集約アドレスを数値昇順でソート
        if (
          saseGatewayPaloAltoDetailCopy.saseGatewayVnConnectCommon &&
          Array.isArray(
            saseGatewayPaloAltoDetailCopy.saseGatewayVnConnectCommon
              .routeAggregationAddressList
          )
        ) {
          saseGatewayPaloAltoDetailCopy.saseGatewayVnConnectCommon.routeAggregationAddressList =
            saseGatewayPaloAltoDetailCopy.saseGatewayVnConnectCommon.routeAggregationAddressList.sortIpAddress();
        } else {
          saseGatewayPaloAltoDetailCopy.saseGatewayVnConnectCommon.routeAggregationAddressList =
            [""];
        }
        const form: SaseGatewayPaloAltoPut = {
          saseGatewayVnConnectCommon: {
            ...saseGatewayPaloAltoDetailCopy.saseGatewayVnConnectCommon,
          },
          saseGatewayVnConnectAct:
            saseGatewayPaloAltoDetailCopy.saseGatewayVnConnectAct,
          saseGatewayVnConnectSby:
            saseGatewayPaloAltoDetailCopy.saseGatewayVnConnectSby,
          maintenance: saseGatewayPaloAltoDetailCopy.maintenance,
          saseGatewayPaloAltoKeyId:
            saseGatewayPaloAltoDetailCopy.saseGatewayPaloAltoKeyId,
        };
        return form;
      } else {
        // 追加
        const form: SaseGatewayPaloAltoPost = {
          saseGatewayVnConnectCommon: {
            bandwidthType: "PF",
            routeAggregation: "OFF",
            routeAggregationAddressList: [""],
            location: "EAST_JAPAN",
            maximumPrefix: 100,
            asNumber: 16550,
          } as SaseGatewayPaloAltoPost["saseGatewayVnConnectCommon"],
          saseGatewayVnConnectAct:
            {} as SaseGatewayPaloAltoPost["saseGatewayVnConnectAct"],
          saseGatewayVnConnectSby:
            {} as SaseGatewayPaloAltoPost["saseGatewayVnConnectSby"],
          maintenance: {} as SaseGatewayPaloAltoPost["maintenance"],
          saseGatewayKeyId: this.saseGatewayKeyId!,
        };
        return form;
      }
    })();

    return {
      form,
      isLoaded: false,
      uploadAlert: null as string | null,
      vpnVnCodeList: [] as VpnVnCode[],
      selectedVpnVn: null as string | null,
      bandwidthOptions: [
        { text: "200Mbps", value: { value: 200, unit: "MBPS" } },
        { text: "300Mbps", value: { value: 300, unit: "MBPS" } },
        { text: "400Mbps", value: { value: 400, unit: "MBPS" } },
        { text: "500Mbps", value: { value: 500, unit: "MBPS" } },
        { text: "600Mbps", value: { value: 600, unit: "MBPS" } },
        { text: "700Mbps", value: { value: 700, unit: "MBPS" } },
        { text: "800Mbps", value: { value: 800, unit: "MBPS" } },
        { text: "900Mbps", value: { value: 900, unit: "MBPS" } },
        { text: "1Gbps", value: { value: 1, unit: "GBPS" } },
        { text: "2Gbps", value: { value: 2, unit: "GBPS" } },
        { text: "3Gbps", value: { value: 3, unit: "GBPS" } },
        { text: "4Gbps", value: { value: 4, unit: "GBPS" } },
        { text: "5Gbps", value: { value: 5, unit: "GBPS" } },
        { text: "6Gbps", value: { value: 6, unit: "GBPS" } },
        { text: "7Gbps", value: { value: 7, unit: "GBPS" } },
        { text: "8Gbps", value: { value: 8, unit: "GBPS" } },
        { text: "9Gbps", value: { value: 9, unit: "GBPS" } },
        { text: "10Gbps", value: { value: 10, unit: "GBPS" } },
      ] as { text: string; value: BandWidth }[],
      routeOptions: [
        { value: "OFF", text: "OFF" },
        { value: "CUSTOM", text: "CUSTOM" },
      ],
      locationOptions: [{ value: "EAST_JAPAN", text: "東日本" }],
      /** Maximum Prefix上限値(変更の場合用) */
      maximumPrefixLimit: null as UpperLimitEntity | null,

      selectedUnit: null as SaseGatewayListEntity | null,
    };
  },
  computed: {
    currentLength(): number {
      return this.form.saseGatewayVnConnectCommon.routeAggregationAddressList
        ? this.form.saseGatewayVnConnectCommon.routeAggregationAddressList
            .length
        : 0;
    },

    /** true: 新規, false: 変更 */
    isAdd(): boolean {
      return !this.saseGatewayPaloAltoDetail;
    },

    vpnVnCodeSelectList(): {
      value: string;
      text: string;
    }[] {
      return this.vpnVnCodeList.map((v) => {
        if (v.vnName) {
          return {
            value: v.vpnVnCode,
            text: v.vnName + ":" + v.vpnVnCode + `(${v.vnType})`,
          };
        } else {
          return { value: v.vpnVnCode, text: v.vpnVnCode };
        }
      });
    },
    /**
     * 品目の選択肢
     * 2つの上限値の最小値以下のオプションを返す
     * - VNコネクト帯域値
     * - 設定可能帯域
     */
    bandwidthSelectList(): { text: string; value: BandWidth }[] {
      // SASEゲートウェイ全体の残り帯域(Mbps)をbpsに変換
      const limit1 = this.$filter.bandwidthToBps({
        value: this.saseGatewayRemainingBandwidth,
        unit: "MBPS",
      });

      // VNコネクト帯域値(Mbps)をbpsに変換
      const limit2 = this.$filter.bandwidthToBps({
        value: this.saseGatewayBandwidthUpperLimit,
        unit: "MBPS",
      });

      // 変更の場合は既存の値が選択肢に含まれない可能性があるため、既存値を追加する
      if (!this.isAdd) {
        // 既存の帯域値をbpsに変換
        const settingBandwidth = this.$filter.bandwidthToBps({
          value:
            this.saseGatewayPaloAltoDetail!.saseGatewayVnConnectCommon.bandwidth
              .value,
          unit: this.saseGatewayPaloAltoDetail!.saseGatewayVnConnectCommon
            .bandwidth.unit,
        });

        // 「limit1: SASEゲートウェイ全体の残り帯域値(bps)」と「settingBandwidth：既存帯域値(bps)」を合計した値
        // ただし品目が10Gbpsを超えることがないため、合計が10Gbpsを超える場合は10Gbpsとする
        let maxAllowedBandwidthMbps = Math.min(
          limit1! + settingBandwidth!,
          this.$filter.bandwidthToBps({ value: 10, unit: "GBPS" })!
        );

        // 2つの上限値のうち、小さい方を採用
        maxAllowedBandwidthMbps = Math.min(maxAllowedBandwidthMbps, limit2!);

        // 全ての品目オプションから、設定可能な帯域以下のものだけをフィルタリング
        const filteredOptions = this.bandwidthOptions.filter((v) => {
          const bps = this.$filter.bandwidthToBps(v.value);
          return bps! <= maxAllowedBandwidthMbps;
        });

        return filteredOptions;
      } else {
        // 2つの上限値のうち、小さい方を採用
        const maxAllowedBandwidthMbps = Math.min(limit1!, limit2!);

        // 全ての品目オプションから、設定可能な帯域以下のものだけをフィルタリング
        const filteredOptions = this.bandwidthOptions.filter((v) => {
          const bps = this.$filter.bandwidthToBps(v.value);
          return bps! <= maxAllowedBandwidthMbps;
        });

        return filteredOptions;
      }
    },

    /** Maximum Prefixの選択肢 */
    maximumPrefixSelectList(): { text: string; value: number }[] {
      if (this.isAdd) {
        return [{ value: 100, text: "100" }];
      } else {
        return [
          { value: 100, text: "100" },
          { value: 200, text: "200" },
          { value: 300, text: "300" },
          { value: 400, text: "400" },
          { value: 500, text: "500" },
          { value: 1000, text: "1000" },
          { value: 1500, text: "1500" },
          { value: 2000, text: "2000" },
        ].filter((v) => v.value <= this.maximumPrefixLimit!.upperLimit);
      }
    },

    vpnVnName(): string {
      if (
        this.saseGatewayPaloAltoDetail!.saseGatewayVnConnectCommon.vpnVnCode.startsWith(
          "D"
        )
      ) {
        return (
          this.saseGatewayPaloAltoDetail!.saseGatewayVnConnectCommon.vnName +
          ":" +
          this.saseGatewayPaloAltoDetail!.saseGatewayVnConnectCommon.vpnVnCode +
          `(${this.saseGatewayPaloAltoDetail!.saseGatewayVnConnectCommon.vnType})`
        );
      } else {
        return this.saseGatewayPaloAltoDetail!.saseGatewayVnConnectCommon
          .vpnVnCode;
      }
    },

    /** 経路集約アドレスの重複チェック用リスト作成 */
    routingAddressList() {
      return (index: number) => {
        return this.form.saseGatewayVnConnectCommon.routeAggregationAddressList
          ? this.form.saseGatewayVnConnectCommon.routeAggregationAddressList.filter(
              (_, num) => num !== index
            )
          : [];
      };
    },

    /**
     * コピー元回線番号選択用のPaloAlto一覧をソートして返す
     * VPN/VNコードの昇順でソート
     * @returns ソート済みのSASEゲートウェイPaloAlto一覧
     */
    sortPaloAltoItems(): (SaseGatewayListEntity & { _trackKey: string })[] {
      if (!this.paloAltoItems || this.paloAltoItems.length === 0) {
        return [];
      }
      return this.paloAltoItems
        .sortBy([(item) => item.saseGatewayVnConnectCommon.vpnVnCode, "asc"])
        .map((item) => ({
          ...item,
          _trackKey: item.saseGatewayVnConnectAct.wnumber,
        }));
    },
  },

  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    async load() {
      if (this.isAdd) {
        this.vpnVnCodeList = (await this.$api.information.getVpnVnCodeList())
          .filter(
            (v: { vnType: string | null }) =>
              v.vnType === "L3" || v.vnType === null
          )
          .sortBy(["vpnVnCode", "asc"]);
      } else {
        // maximumPrefixの上限値を取得
        this.maximumPrefixLimit = (
          await this.$api.upperLimit.getUpperLimitLine({
            upperLimitLineManageUnit: "SASE_GATEWAY",
            saseGatewayServiceType: "PALOALTO",
            wnumber:
              this.saseGatewayPaloAltoDetail!.saseGatewayVnConnectAct.wnumber,
          })
        ).saseGateway!.upperLimitList!.find(
          (v: { upperLimitItemName: string }) =>
            v.upperLimitItemName === "BGP4の最大経路数"
        )!;
      }
    },

    /** 経路集約アドレス削除 */
    removeRouteAddress(index: number, remove: (idx: number) => void) {
      const list =
        this.form.saseGatewayVnConnectCommon.routeAggregationAddressList!;
      if (list.length > 1) {
        list.splice(index, 1);
        // ValidationにFieldを削除することを伝える
        remove(index);
      } else {
        this.form.saseGatewayVnConnectCommon.routeAggregationAddressList = [""];
      }
    },

    /** 経路集約アドレス追加 */
    addRouteAddress(push: (item: any) => void) {
      const addItem = "";
      this.form.saseGatewayVnConnectCommon.routeAggregationAddressList = [
        ...this.form.saseGatewayVnConnectCommon.routeAggregationAddressList!,
        addItem,
      ];
      // ValidationにFieldを追加することを伝える
      push(addItem);
    },

    /** コピー元回線番号 */
    labelUnit({
      saseGatewayVnConnectCommon: { vpnVnCode, vnType },
      saseGatewayVnConnectAct: { vnConnectName },
      saseGatewayVnConnectAct: { wnumber },
      saseGatewayVnConnectCommon: { saseGatewayServiceType },
      saseGatewayVnConnectCommon: { location },
    }: SaseGatewayListEntity): string {
      const displayVpnVnCode = vpnVnCode.startsWith("D")
        ? `${vpnVnCode}(${vnType})`
        : vpnVnCode;
      const displayType = this.$filter.enumTo(
        saseGatewayServiceType,
        "saseGatewayServiceType"
      );
      const displayLocation = this.$filter.enumTo(location, "location");

      return `${displayVpnVnCode} / ${vnConnectName} / ${wnumber} / ${displayType} / ${displayLocation}`;
    },
    async setProperty() {
      if (this.selectedUnit) {
        const setForm = (
          await this.$api.saseGateway.getPaloAltoDetail(
            this.selectedUnit.saseGatewayVnConnectAct.wnumber
          )
        ).maintenance;
        if (setForm) {
          this.form.maintenance = setForm;
        }
      }
    },

    /**
     * 設定ダウンロード処理
     */
    downloadConfig() {
      if (this.isAdd) {
        // 追加時
        this.$service.configDownload.downloadSaseGatewayPaloAlto(
          "add",
          this.form,
          this.selectedVpnVn ? this.selectedVpnVn : null
        );
      } else {
        // 変更時
        this.$service.configDownload.downloadSaseGatewayPaloAlto(
          "modify",
          this.form
        );
      }
    },

    /**
     * 設定アップロード処理
     */
    async uploadConfig() {
      try {
        const uploadConfig = this.isAdd
          ? await this.$service.configDownload.uploadSaseGatewayPaloAlto("add")
          : await this.$service.configDownload.uploadSaseGatewayPaloAlto(
              "modify"
            );
        this.uploadAlert = null;
        await this.$confirm(
          "Palo Alto向けVNコネクト設定を上書きします。よろしいですか？"
        );

        // 追加の場合のみ変更可能な項目を設定
        if (this.isAdd && uploadConfig.operationType === "add") {
          const formPost = this.form as SaseGatewayPaloAltoPost;

          if (uploadConfig.saseGatewayVnConnectCommon?.vpnVnCode) {
            this.selectedVpnVn =
              uploadConfig.saseGatewayVnConnectCommon.vpnVnCode;
            formPost.saseGatewayVnConnectCommon!.vpnVnCode =
              uploadConfig.saseGatewayVnConnectCommon.vpnVnCode;
          }
          if (uploadConfig.saseGatewayVnConnectCommon?.location) {
            formPost.saseGatewayVnConnectCommon!.location =
              uploadConfig.saseGatewayVnConnectCommon.location;
          }
          if (uploadConfig.saseGatewayVnConnectAct?.serviceKey) {
            formPost.saseGatewayVnConnectAct!.serviceKey =
              uploadConfig.saseGatewayVnConnectAct.serviceKey;
          }
          if (uploadConfig.saseGatewayVnConnectSby?.serviceKey) {
            formPost.saseGatewayVnConnectSby!.serviceKey =
              uploadConfig.saseGatewayVnConnectSby.serviceKey;
          }
        }

        // 共通設定項目
        if (uploadConfig.saseGatewayVnConnectCommon.bandwidth) {
          this.form.saseGatewayVnConnectCommon.bandwidth =
            uploadConfig.saseGatewayVnConnectCommon.bandwidth;
        }
        if (
          uploadConfig.saseGatewayVnConnectCommon.maximumPrefix !== undefined
        ) {
          this.form.saseGatewayVnConnectCommon.maximumPrefix =
            uploadConfig.saseGatewayVnConnectCommon.maximumPrefix;
        }
        if (uploadConfig.saseGatewayVnConnectCommon.routeAggregation) {
          this.form.saseGatewayVnConnectCommon.routeAggregation =
            uploadConfig.saseGatewayVnConnectCommon.routeAggregation;
        }
        if (
          uploadConfig.saseGatewayVnConnectCommon.routeAggregationAddressList
        ) {
          this.form.saseGatewayVnConnectCommon.routeAggregationAddressList =
            uploadConfig.saseGatewayVnConnectCommon.routeAggregationAddressList
              .length > 0
              ? uploadConfig.saseGatewayVnConnectCommon
                  .routeAggregationAddressList
              : [""];

          // validation-arrayのフィールドを強制的に再描画
          this.isLoaded = false;
          await this.$nextTick();
          this.isLoaded = true;
          await this.$nextTick();
        }
        if (uploadConfig.saseGatewayVnConnectCommon.description !== undefined) {
          this.form.saseGatewayVnConnectCommon.description =
            uploadConfig.saseGatewayVnConnectCommon.description;
        }

        // VNコネクト名
        if (uploadConfig.saseGatewayVnConnectAct?.vnConnectName) {
          this.form.saseGatewayVnConnectAct!.vnConnectName =
            uploadConfig.saseGatewayVnConnectAct.vnConnectName;
        }
        if (uploadConfig.saseGatewayVnConnectSby?.vnConnectName) {
          this.form.saseGatewayVnConnectSby!.vnConnectName =
            uploadConfig.saseGatewayVnConnectSby.vnConnectName;
        }

        // 保守連絡先情報
        if (uploadConfig.maintenance) {
          this.form.maintenance = uploadConfig.maintenance;
        }
      } catch (e) {
        this.uploadAlert = (e as UploadError).message;
      }
    },

    /**
     * フォーム送信処理
     */
    async submit() {
      const form = {
        ...this.form,
        saseGatewayVnConnectCommon: {
          ...this.form.saseGatewayVnConnectCommon,
          routeAggregationAddressList:
            this.form.saseGatewayVnConnectCommon.routeAggregation === "OFF"
              ? null
              : this.form.saseGatewayVnConnectCommon
                  .routeAggregationAddressList,
        },
      } as SaseGatewayPaloAltoPost | SaseGatewayPaloAltoPut;

      if (this.isAdd) {
        // 追加の場合
        // 確認モーダルの表示
        let displayVnName;
        (form as SaseGatewayPaloAltoPost).saseGatewayVnConnectCommon.vpnVnCode =
          this.selectedVpnVn!;
        displayVnName = this.vpnVnCodeList.find(
          (v) =>
            v.vpnVnCode ===
            (form as SaseGatewayPaloAltoPost).saseGatewayVnConnectCommon
              .vpnVnCode
        )!.vnName;

        await this.$modal.show(SaseGatewayPaloAltoVnConnectionConfirm, {
          saseGatewayPaloAltoDetail: {
            saseGatewayVnConnectCommon: {
              ...form.saseGatewayVnConnectCommon,
              vnName: displayVnName,
              routingType: "BGP4",
            },
            saseGatewayVnConnectAct: {
              ...form.saseGatewayVnConnectAct,
              localPreference: "HIGH_PRIORITY",
              med: "LOW_PRIORITY",
            },
            saseGatewayVnConnectSby: {
              ...form.saseGatewayVnConnectSby,
              localPreference: "LOW_PRIORITY",
              med: "HIGH_PRIORITY",
            },
            maintenance: form.maintenance,
          },
          displayType: "A",
        });
        await this.$api.saseGateway.postPaloAlto(
          form as SaseGatewayPaloAltoPost
        );

        // モーダルを閉じる
        (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      } else {
        // 変更の場合
        // 確認モーダルの表示
        await this.$modal.show(SaseGatewayPaloAltoVnConnectionConfirm, {
          saseGatewayPaloAltoDetail: form,
          displayType: "M",
        });
        // 変更APIを呼び出し
        await this.$api.saseGateway.putPaloAlto(
          this.saseGatewayPaloAltoDetail!.saseGatewayVnConnectAct.wnumber,
          form as SaseGatewayPaloAltoPut
        );

        // モーダルを閉じる
        (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      }
    },
  },
});
</script>
